import { Exercise, Phase, ScheduleEntryColourCode, SessionSequence } from '../../entities';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';

export class PauseAtWorkoutStarting implements ISessionSequenceStrategy {
    public getSessionSequence(
        exercise: Exercise,
        alernativeExercise: Exercise,
        secondAternativeExercise: Exercise,
        thirdAlternateExercise: Exercise,
        zone: number,
        quarter: number,
      ): SessionSequence[] {
        return [{
            durationInMilliseconds: 120,
            sequence: [{
                durationInMilliseconds: 120,
                videoFile: exercise.uniqueReferenceNumber,
                exerciseVersion: exercise._rev,
                displayName: exercise.name,
                displayBurnOrBuildIcon: true,
                progressColourCode: ScheduleEntryColourCode.Rest,
                progressText: 'Starting in {seconds}',
                showProcessedMetrics: false,
                showCalculatedMetrics: false,
                audioSoundEvent: undefined,
                tips: Exercise.getFormattedTips(exercise),
                phase: Phase.Rest,
                zone,
                quarter,
            }],
        }];
    }
}
